import { configureStore } from '@reduxjs/toolkit';
import menuReducer from './menuSlice';
import tokensReducer from './tokensSlice';

const store = configureStore({
  reducer: {
    menu: menuReducer,
    tokens: tokensReducer,
  },
});

export default store;
